import { tdsFetch } from '@/utils/fetch';
import encrypt from '@/utils/encrypt'
import { useUserStoreWithOut } from '@/store/modules/user'

const prefix = '/disclosure-project';
const VUE_APP_TDS_SERVER = process.env.VUE_APP_TDS_SERVER;

/** 开发环境 SSE 直连后端，避免 webpack-dev-server 代理缓冲导致无流式输出 */
const resolveAssistStreamUrl = (id, step = 3) => {
  const path = `${prefix}/step/${step}/assist/${id}/stream`
  if (process.env.NODE_ENV === 'development') {
    const backend = (process.env.VUE_APP_PROXY_BACKEND_TARGET || 'http://127.0.0.1:8083').replace(/\/$/, '')
    return `${backend}/system/disclosure${path}`
  }
  return `${VUE_APP_TDS_SERVER}${path}`
}

// 交底书初核验信息
export const fetchSetp1Info = (id) => {
  return tdsFetch(`${prefix}/step/1/${id}`, { method: 'GET' })
}

// 上传交底书
export const fetchGenerateStep1Analysis = (id) => {
  return tdsFetch(`${prefix}/step/1/generate/${id}`, {
    method: 'POST',
  })
}

export const fetchUpdateStep1Info = (data) => {
  return tdsFetch(`${prefix}/step/1`, {
    method: 'PUT',
    body: data
  })
}

export const fetchStep1Upload = (data) => {
  return tdsFetch(`${prefix}/step/1/upload-file`, {
    method: 'POST',
    body: data
  })
}

// 上传交底书
export const fetchStep2Upload = (projectId, data) => {
  return tdsFetch(`${prefix}/step/2/normal-upload?id=${projectId}`, {
    method: 'POST',
    body: data
  })
}

// 技术方案确认-原文标注
export const fetchWordExtract = (id, path) => {
  return tdsFetch(`${prefix}/step/2/component/word-extract/${id}?path=${path}`,  {
    method: 'POST',
  })
}

// 技术方案确认-重新生成
export const fetchRepeatWordExtract = (id, data) => {
  return tdsFetch(`${prefix}/step/2/component/repeat-word-extract/${id}`,  {
    method: 'POST',
    body: data,
  })
}

export const fetchGenerateFeatureBreakdown = (id) => {
  return tdsFetch(`${prefix}/step/2/component/feature-breakdown/${id}`, {
    method: 'POST',
  })
}

export const fetchGenerateInventiveIdea = (id) => {
  return tdsFetch(`${prefix}/step/2/component/inventive-idea/${id}`, {
    method: 'POST',
  })
}

export const fetchGenerateDrawingAnalysis = (id) => {
  return tdsFetch(`${prefix}/step/2/component/drawing-analysis/${id}`, {
    method: 'POST',
  })
}

export const fetchGenerateTechnicalFlow = (id) => {
  return tdsFetch(`${prefix}/step/2/component/technical-flow/${id}`, {
    method: 'POST',
  })
}

export const fetchGenerateProtectionStrategy = (id) => {
  return tdsFetch(`${prefix}/step/2/component/protection-strategy/${id}`, {
    method: 'POST',
  })
}

export const fetchGenerateStrategicAlignment = (id) => {
  return tdsFetch(`${prefix}/step/2/component/strategic-alignment/${id}`, {
    method: 'POST',
  })
}

export const fetchGenerateTagLabel = (id) => {
  return tdsFetch(`${prefix}/step/2/component/tag-label/${id}`, {
    method: 'POST',
  })
}

export const fetchGenerateNoveltySearchText = (id) => {
  return tdsFetch(`${prefix}/step/2/component/novelty-analysis/search-text/${id}`, {
    method: 'POST',
  })
}

export const fetchSearchNovelty = (id, data) => {
  return tdsFetch(`${prefix}/step/2/component/novelty-analysis/search/${id}`, {
    method: 'POST',
    body: data,
  })
}

export const fetchSearchNoveltyDocument = (id, data) => {
  return tdsFetch(`${prefix}/step/2/component/novelty-analysis/document/${id}`, {
    method: 'POST',
    body: data,
  })
}

export const fetchAutoNoveltyAnalysis = (id, data) => {
  return tdsFetch(`${prefix}/step/2/component/novelty-analysis/auto/${id}`, {
    method: 'POST',
    body: data,
  })
}

export const fetchAutoNoveltyAnalysisTaskStatus = (id, taskId) => {
  return tdsFetch(`${prefix}/step/2/component/novelty-analysis/task/${id}/${taskId}`, {
    method: 'GET',
  })
}

export const fetchManualNoveltyAnalysis = (id, data) => {
  return tdsFetch(`${prefix}/step/2/component/novelty-analysis/manual/${id}`, {
    method: 'POST',
    body: data,
  })
}

// 交底书初核验状态变更
export const fetchInitializeCreativityAnalysis = (id) => {
  return tdsFetch(`${prefix}/step/2/component/creativity-analysis/initialize/${id}`, {
    method: 'POST',
  })
}

export const fetchGenerateCreativityCards = (id, data) => {
  return tdsFetch(`${prefix}/step/2/component/creativity-analysis/cards/${id}`, {
    method: 'POST',
    body: data,
  })
}

export const fetchInitializeCompletenessAnalysis = (id) => {
  return tdsFetch(`${prefix}/step/2/component/completeness-analysis/initialize/${id}`, {
    method: 'POST',
  })
}

export const fetchStep1ChangeStatus = (id) => {
  return tdsFetch(`${prefix}/step/1/change-status/${id}`, {
    method: 'PUT',
  })
}

// 技术方案确认查看信息
export const fetchStep2Info = (id) => {
  return tdsFetch(`${prefix}/step/2/${id}`, {
    method: 'GET',
  })
}

export const fetchStep2ComponentStatus = (id) => {
  return tdsFetch(`${prefix}/step/2/component/status/${id}`, {
    method: 'GET',
  })
}

export const fetchUpdateStep2Info = (data) => {
  return tdsFetch(`${prefix}/step/2`, {
    method: 'PUT',
    body: data,
  }) 
}

// 保存组件信息
export const fetchSaveComponent = (data) => {
  return tdsFetch(`${prefix}/step/2/component`, {
    method: 'PUT',
    body: data,
  })
}

// 导出原文标注
export const fetchExportNote = (id) => {
  return tdsFetch(`${prefix}/step/export/comp-ann/${id}/oss`, {
    method: 'POST',
  })
}

// Step2 → Step3 状态变更（2→3）
export const fetchStep2ChangeStatus = (id, force = false) => {
  return tdsFetch(`${prefix}/step/2/change-status/${id}?force=${force}`, {
    method: 'PUT',
  })
}

// Step3 权利要求撰写
export const fetchStep3Info = (id) => {
  return tdsFetch(`${prefix}/step/3/${id}`, {
    method: 'GET',
  })
}

export const fetchUpdateStep3 = (data) => {
  return tdsFetch(`${prefix}/step/3`, {
    method: 'PUT',
    body: data,
  })
}

export const fetchGenerateStep3 = (id, data = { overwrite: true }) => {
  return tdsFetch(`${prefix}/step/3/generate/${id}`, {
    method: 'POST',
    body: data,
  })
}

export const fetchStep3Assist = (id, data) => {
  return tdsFetch(`${prefix}/step/3/assist/${id}`, {
    method: 'POST',
    body: data,
  })
}

/** Step3/4 撰写助手 SSE 流式输出 */
const streamAssist = (step, id, data, callbacks = {}) => {
  const {
    onDelta,
    onReasoningDelta,
    onBodyDelta,
    onDone,
    onError,
    onStart,
    signal,
    timeoutMs = 120000,
    idleTimeoutMs = 90000,
  } = callbacks
  const userStore = useUserStoreWithOut()
  const token = localStorage.getItem('token')
  const headers = {
    'Content-Type': 'application/json',
    Accept: 'text/event-stream',
  }
  if (token) {
    headers.Authorization = token
    headers['X-Access-Token'] = token
  }
  if (userStore.userInfo?.loginTenantId) {
    headers['X-Tenant-Id'] = encrypt(userStore.userInfo.loginTenantId)
  }

  return new Promise((resolve, reject) => {
    let settled = false
    const finish = (fn, value) => {
      if (settled) return
      settled = true
      fn(value)
    }
    const controller = new AbortController()
    const timeoutId = setTimeout(() => controller.abort(), timeoutMs)
    let idleTimer = setTimeout(() => controller.abort(), idleTimeoutMs)
    const touchIdle = () => {
      clearTimeout(idleTimer)
      idleTimer = setTimeout(() => controller.abort(), idleTimeoutMs)
    }
    if (signal) {
      if (signal.aborted) controller.abort()
      else signal.addEventListener('abort', () => controller.abort(), { once: true })
    }

    ;(async () => {
      let gotDone = false
      let gotAnyEvent = false
      try {
        const response = await fetch(resolveAssistStreamUrl(id, step), {
          method: 'POST',
          headers,
          body: JSON.stringify(data),
          signal: controller.signal,
        })
        if (!response.ok) {
          const text = await response.text()
          let msg = `请求失败 (${response.status})`
          try {
            const j = JSON.parse(text)
            msg = j.message || j.msg || msg
          } catch {
            // ignore parse error
          }
          throw new Error(msg)
        }
        const contentType = response.headers.get('content-type') || ''
        if (!contentType.includes('event-stream')) {
          throw new Error('服务端未返回流式响应')
        }
        const reader = response.body?.getReader()
        if (!reader) {
          throw new Error('无法读取流式响应')
        }
        const decoder = new TextDecoder()
        let buffer = ''
        while (true) {
          const { done, value } = await reader.read()
          if (done) break
          buffer += decoder.decode(value, { stream: true })
          const lines = buffer.split('\n')
          buffer = lines.pop() || ''
          for (const line of lines) {
            const trimmed = line.trim()
            if (!trimmed.startsWith('data:')) continue
            const jsonStr = trimmed.slice(5).trim()
            if (!jsonStr || jsonStr === '[DONE]') continue
            let event
            try {
              event = JSON.parse(jsonStr)
            } catch {
              continue
            }
            gotAnyEvent = true
            touchIdle()
            if (event.type === 'start') {
              onStart?.()
            } else if (event.type === 'reasoning_delta') {
              onReasoningDelta?.(event.content || '')
            } else if (event.type === 'delta') {
              onDelta?.(event.content || '')
            } else if (event.type === 'body_delta') {
              onBodyDelta?.(event.content || '')
            } else if (event.type === 'done') {
              gotDone = true
              onDone?.(event)
              finish(resolve, event)
              return
            } else if (event.type === 'error') {
              const err = new Error(event.message || '助手请求失败')
              onError?.(err)
              finish(reject, err)
              return
            }
          }
        }
        if (!gotDone) {
          const err = new Error(gotAnyEvent ? '流式连接已结束但未收到完整回复' : '未收到流式数据')
          onError?.(err)
          finish(reject, err)
        }
      } catch (err) {
        if (err?.name === 'AbortError') {
          const timeoutErr = new Error(
            gotAnyEvent ? '流式响应超时，请稍后重试' : '助手长时间无响应，请稍后重试',
          )
          onError?.(timeoutErr)
          finish(reject, timeoutErr)
          return
        }
        onError?.(err)
        finish(reject, err)
      } finally {
        clearTimeout(timeoutId)
        clearTimeout(idleTimer)
      }
    })()
  })
}

export const streamStep3Assist = (id, data, callbacks = {}) => streamAssist(3, id, data, callbacks)

export const streamStep4Assist = (id, data, callbacks = {}) => streamAssist(4, id, data, {
  ...callbacks,
  timeoutMs: callbacks.timeoutMs ?? 180000,
  idleTimeoutMs: callbacks.idleTimeoutMs ?? 90000,
})

// Step3 → Step4 状态变更（3→4）
export const fetchStep3ChangeStatus = (id) => {
  return tdsFetch(`${prefix}/step/3/change-status/${id}`, {
    method: 'PUT',
  })
}

export const fetchExportStep3 = (id) => {
  return tdsFetch(`${prefix}/step/3/export/${id}`, {
    method: 'POST',
    responseType: 'blob',
  })
}

// Step4 说明书撰写
export const fetchStep4Info = (id) => {
  return tdsFetch(`${prefix}/step/4/${id}`, {
    method: 'GET',
  })
}

export const fetchUpdateStep4 = (data) => {
  return tdsFetch(`${prefix}/step/4`, {
    method: 'PUT',
    body: data,
  })
}

export const fetchGenerateStep4 = (id, data = { overwrite: true }) => {
  return tdsFetch(`${prefix}/step/4/generate/${id}`, {
    method: 'POST',
    body: data,
  })
}

export const fetchExportStep4 = (id) => {
  return tdsFetch(`${prefix}/step/4/export/${id}`, {
    method: 'POST',
    responseType: 'blob',
  })
}

export const fetchGenerateStep4Section = (id, data) => {
  return tdsFetch(`${prefix}/step/4/generate-section/${id}`, {
    method: 'POST',
    body: data,
  })
}

export const fetchStep4Assist = (id, data) => {
  return tdsFetch(`${prefix}/step/4/assist/${id}`, {
    method: 'POST',
    body: data,
  })
}

/** Step4 完成撰写：4→5 */
export const fetchStep4ChangeStatus = (id) => {
  return tdsFetch(`${prefix}/step/4/change-status/${id}`, {
    method: 'PUT',
  })
}

/** Step4 重新打开编辑：5→4 */
export const fetchStep4ReopenEditing = (id) => {
  return tdsFetch(`${prefix}/step/4/reopen-editing/${id}`, {
    method: 'PUT',
  })
}
